﻿import ActivePage from "../activePage";

export default class PatCECountrySetup extends ActivePage {

    constructor() {
        super();
    }

    tabChangeSetListener = () => {
        const self = this;
        $('#patCECountrySetup-tab a').on('click',
            (e) => {
                e.preventDefault();
                const tab = e.target.id;
                if (this.tabsLoaded.indexOf(tab) === -1) {
                    this.tabsLoaded.push(tab);
                    this.loadTabContent(tab);
                }
            });

        $(document).ready(function () {

        });
    }

    loadTabContent(tab) {
        switch (tab) {

            case "":
                break;
        }
    }

    getParentTStamp = () => {
        const container = $(`#${this.detailContentContainer}`);
        const tStamp = container.find("input[name='tStamp']");
        return tStamp.val();
    }    

    /* main copy */
    getCountryFromCopyScreen = () => {
        const country = $("#patCECountrySetupCopyDialog").find("input[name='Country']");
        return { country: country.val() };
    }

    showCopyScreen() {
        const popupContainer = $(".site-content .popup").last();
        const dialogContainer = popupContainer.find("#patCECountrySetupCopyDialog");
        let entryForm = dialogContainer.find("form")[0];
        dialogContainer.modal("show");
        const self = this;

        entryForm = $(entryForm);
        const afterSubmit = function (result) {
            const dataContainer = $('#' + self.mainDetailContainer).find(".cpiDataContainer");
            if (dataContainer.length > 0) {
                setTimeout(function () {
                    dataContainer.empty();
                    dataContainer.html(result);
                }, 1000);
            }
        };
        entryForm.cpiPopupEntryForm({ dialogContainer: dialogContainer, afterSubmit: afterSubmit });
    }

    costSetupDataTypeChange = (e) => {
        var selectedType = $("#" + e.sender.element[0].id).data("kendoDropDownList").text();
        
        var datePicker = document.getElementById('guideDatePicker');
        var dateRangePicker = document.getElementById('guideDateRangePicker');       
        var boolBox = document.getElementById('guideBoolean');
        var altCostBox = document.getElementById('guideAltCost');
        var defaultCostBox = document.getElementById('guideDefaultCost');
        var numBox = document.getElementById('guideNumeric');
        var multCostBox = document.getElementById('guideMultCost');
        var costFactorSettings = document.getElementById('costFactorSettings');
        var useCostFactorSwitch = document.getElementById('useCostFactorSwitch');

        datePicker.style.display = 'none'
        dateRangePicker.style.display = 'none';
        boolBox.style.display = 'none'
        numBox.style.display = 'none';
        multCostBox.style.display = 'none';
        altCostBox.style.display = 'none';
        defaultCostBox.style.display = 'none';
        costFactorSettings.style.display = 'none';
        useCostFactorSwitch.style.display = 'none';

        if (selectedType == 'String') {           
            defaultCostBox.style.display = 'block';
        }
        else if (selectedType == 'Date') {
            datePicker.style.display = 'block'
        }     
        else if (selectedType == 'Date Range') {
            dateRangePicker.style.display = 'block';
            altCostBox.style.display = 'block';
            defaultCostBox.style.display = 'block';
        }       
        else if (selectedType == 'Numeric') {
            var costTypeDD = $('#CostType').data('kendoDropDownList');
            if (costTypeDD && costTypeDD.value() && costTypeDD.value().toLowerCase() === "translation") {
                useCostFactorSwitch.style.display = 'block';
            }            

            var useCostFactorSwitch = $('.costGuideEditor input[name="UseCostFactor"]');
            if(useCostFactorSwitch.is(':checked')) {
                costFactorSettings.style.display = 'flex';   
                
                numBox.style.display = 'none';                
                multCostBox.style.display = 'none';
                altCostBox.style.display = 'none';
                defaultCostBox.style.display = 'none';
            }
            else {
                numBox.style.display = 'contents';
                $('#NumericOpt').data('kendoDropDownList').select(0);
                multCostBox.style.display = 'block';
                altCostBox.style.display = 'block';
                defaultCostBox.style.display = 'block';

                costFactorSettings.style.display = 'none';   
            }            
        }       
        else if (selectedType == 'Boolean') {
            boolBox.style.display = 'block'
            altCostBox.style.display = 'block';
            defaultCostBox.style.display = 'block';
        }
    }

    costSetupCostTypeChange = (e) => {
        var selectedCostType = $("#" + e.sender.element[0].id).data("kendoDropDownList").text();                  
       
        var altCostBox = document.getElementById('guideAltCost');
        var defaultCostBox = document.getElementById('guideDefaultCost');
        var numBox = document.getElementById('guideNumeric');
        var multCostBox = document.getElementById('guideMultCost');
        var costFactorSettings = document.getElementById('costFactorSettings');
        var useCostFactorSwitch = document.getElementById('useCostFactorSwitch');      
        
        if (selectedCostType) {            
            useCostFactorSwitch.style.display = 'none';
            if (selectedCostType.toLowerCase() === "translation") {                
                var dataTypeDD = $('#DataType').data('kendoDropDownList');
                if (dataTypeDD && dataTypeDD.value() && dataTypeDD.text().toLowerCase() === "numeric") {
                    numBox.style.display = 'none';
                    multCostBox.style.display = 'none';
                    altCostBox.style.display = 'none';
                    defaultCostBox.style.display = 'none';
                    costFactorSettings.style.display = 'none';

                    useCostFactorSwitch.style.display = 'block';

                    var useCostFactorSwitch = $('.costGuideEditor input[name="UseCostFactor"]');
                    if(useCostFactorSwitch.is(':checked')) {
                        costFactorSettings.style.display = 'flex';   
                
                        numBox.style.display = 'none';                
                        multCostBox.style.display = 'none';
                        altCostBox.style.display = 'none';
                        defaultCostBox.style.display = 'none';
                    }
                    else {
                        numBox.style.display = 'contents';
                        $('#NumericOpt').data('kendoDropDownList').select(0);
                        multCostBox.style.display = 'block';
                        altCostBox.style.display = 'block';
                        defaultCostBox.style.display = 'block';

                        costFactorSettings.style.display = 'none';   
                    }            
                }
            }
        }        
    }

    costChildDataTypeChange = (e) => {
        var selectedType = $("#" + e.sender.element[0].id).data("kendoDropDownList").text();

        var datePicker = document.getElementById('guideChildDatePicker');
        var dateRangePicker = document.getElementById('guideChildDateRangePicker');
        var boolBox = document.getElementById('guideChildBoolean');
        var altCostBox = document.getElementById('guideChildAltCost');
        var defaultCostBox = document.getElementById('guideChildDefaultCost');
        var numBox = document.getElementById('guideChildNumeric');
        var numBox2 = document.getElementById('guideChildNumeric2');
        var multCostBox = document.getElementById('guideChildMultCost');
        var altNumBox = document.getElementById('guideChildAltNumeric');
        var altNumBox2 = document.getElementById('guideChildAltNumeric2');


        datePicker.style.display = 'none'
        dateRangePicker.style.display = 'none';
        boolBox.style.display = 'none'
        numBox.style.display = 'none';
        numBox2.style.display = 'none';
        multCostBox.style.display = 'none';
        altNumBox.style.display = 'none';
        altNumBox2.style.display = 'none';
        altCostBox.style.display = 'none';
        defaultCostBox.style.display = 'none';

        if (selectedType == 'String') {
            defaultCostBox.style.display = 'block';
        }
        else if (selectedType == 'Date') {
            datePicker.style.display = 'block'
        }
        else if (selectedType == 'Date Range') {
            dateRangePicker.style.display = 'block';
            altCostBox.style.display = 'block';
            defaultCostBox.style.display = 'block';
        }
        else if (selectedType == 'Numeric') {
            numBox.style.display = 'block';
            numBox2.style.display = 'block';
            $('#NumericOptChild').data('kendoDropDownList').select(0);
            multCostBox.style.display = 'block';
            altCostBox.style.display = 'block';
            defaultCostBox.style.display = 'block';
        }
        else if (selectedType == 'Boolean') {
            boolBox.style.display = 'block'
            altCostBox.style.display = 'block';
            defaultCostBox.style.display = 'block';
        }
        else if (selectedType == 'Numeric Range') {
            numBox.style.display = 'block';
            numBox2.style.display = 'block';
            altNumBox.style.display = 'block';
            altNumBox2.style.display = 'block';
            $('#NumericOptChild').data('kendoDropDownList').select(0);
            $('#NumericAltOptChild').data('kendoDropDownList').select(0);
            multCostBox.style.display = 'block';
            altCostBox.style.display = 'block';
            defaultCostBox.style.display = 'block';
        }
    }

    costChildDataTypeData = (e) => {
        var dataTypeDD = $("#CDataType").data("kendoDropDownList");       
        var parentRow = dataTypeDD.wrapper.closest("tr.k-detail-row").prev("tr");
        var parentGrid = parentRow.closest("[data-role=grid]").data("kendoGrid");
        var parentData = parentGrid.dataItem(parentRow);
        
        return {
            parentDataType: parentData.DataType
        };
    }
}
